import client from './client'

export default {
  // 动态
  async getUserDynamicsList (userId, page = 1, limit = 20) {
    const url = '/userDynamics/list'
    const res = await client.get(url, {
      params: {
        userId, page, limit
      }
    })
    return res.data.data
  },
  async getUserDynamicsListV2 (userId, page = 1, limit = 20) {
    const url = '/v2/userDynamics/list'
    const res = await client.get(url, {
      params: {
        userId, page, limit
      }
    })
    return res.data.data
  },
  // 直播回放
  async authorLiveList (userId) {
    const url = `/live/author/tape/${userId}`
    const res = await client.get(url)
    return res.data.data
  },
  // 直播回放 -- 分页加载
  async authorLiveListPage ({userId, page = 1, limit = 10}) {
    const url = `/h5/live/author/tape/${userId}`
    const res = await client.get(url, {
      params: {
        page, limit
      }
    })
    return res.data.data
  },
  // 专辑
  async getAlbumsList (userId, page = 1, limit = 10) {
    const url = `/author/${userId}/albums`
    const res = await client.get(url, {
      params: {
        page,
        limit
      }
    })
    return res.data.data
  },
  async getAlbumsListV2 (userId, page = 1, limit = 10) {
    const url = `/v2/author/${userId}/albums`
    const res = await client.get(url, {
      params: {
        page,
        limit
      }
    })
    return res.data.data
  },
  // 获取文章
  async getAuthorArticles (authorUid, page = 1, limit = 10) {
    const url = `/author/${authorUid}/articles`
    const res = await client.get(url, {
      params: {
        page,
        limit
      }
    })
    return res.data.data
  }
}



// WEBPACK FOOTER //
// ./src/apis/ultron-api/author.js